// extracted by mini-css-extract-plugin
export default {"root":"FormVerticalWrapper_root__1ikCW"};